<template>
	<div v-if="item.seller_id" class="cd-sellers">
		<div v-if="item.seller_code != '9999' && labels.get('sellers_info') != 'sellers_info'" class="cd-sellers-info">
			<span v-html="labels.get('sellers_info')"></span>
			<div v-if="labels.get('sellers_info_btn') != 'sellers_info_btn'" class="cd-sellers-info-btn" @click="flyoutLabel(labels.get('sellers_info_flyout_title'), labels.get('sellers_info_flyout'))">{{ labels.get('sellers_info_btn') }}</div>
		</div>

		<div class="cd-seller-top">
			<div v-if="item.seller_url && item.seller_title" class="cd-seller-title">
				<span v-if="item.seller_title"
					>{{ labels.get('seller_item_title') }} <NuxtLink :to="item.seller_url_product_page ? item.seller_url_product_page_without_domain : item.seller_url_without_domain">{{ item.seller_title }}</NuxtLink></span
				>
			</div>
		</div>
		<div v-if="item.offers_other_total" class="cd-seller-desc cd-flyout-btn" @click="flyoutSellers(item.offers, item.offer_id)" v-html="offersDescl"></div>
	</div>
	<div v-if="firstMainOffer && firstMainOffer.status && firstMainOffer.status != 7" class="cd-seller-item special">
		<div class="cd-seller-item-col1">
			<div class="cd-seller-item-info">
				<div class="cd-seller-item-price">{{ formatCurrency(firstMainOffer.price_custom) }}</div>
			</div>
			<div v-if="shippingDate" class="cd-seller-item-shipping">
				<span v-if="new Date(offerShippingDate * 1000).toDateString() === new Date().toDateString()" v-html="labels.get('seller_item_time_of_delivery_today').replace('%s%', shippingDate)"></span>
				<span v-else-if="new Date(offerShippingDate * 1000).toDateString() === tomorrow.toDateString()" v-html="labels.get('seller_item_time_of_delivery_tomorow').replace('%s%', shippingDate)"></span>
				<span v-else v-html="labels.get('seller_item_time_of_delivery').replace('%s%', shippingDate)"></span>
			</div>
			<div class="cd-seller-item-bottom">
				<div class="cd-seller-item-title">
					<NuxtLink v-if="firstMainOffer.seller_title" :to="firstMainOffer.seller_url_product_page ? firstMainOffer.seller_url_product_page_without_domain : firstMainOffer.seller_url_without_domain">{{ firstMainOffer.seller_title }}</NuxtLink>
				</div>
			</div>
		</div>
		<div @click="selectOffer(firstMainOffer.shopping_cart_code)" class="cd-seller-item-btn btn">
			<span class="selected">{{ labels.get('seller_selected') }}</span>
			<span class="unselected">{{ labels.get('seller_select') }}</span>
		</div>
	</div>
</template>

<script setup>
	import {config} from './hapi.config';
	const labels = useLabels();
	const {emit} = useEventBus();
	const props = defineProps(['item']);
	const {formatDate} = useText();
	const {formatCurrency} = useCurrency();

	const firstOtherOffer = computed(() => {
		return props.item.first_other_offer_id ? props.item?.offers?.find(offer => offer.id === props.item.first_other_offer_id.toString()) : null;
	});
	const firstMainOffer = computed(() => {
		return props.item.first_main_seller_offer_id ? props.item?.offers?.find(offer => offer.id === props.item.first_main_seller_offer_id.toString()) : null;
	});
	const offersDescl = computed(() => {
		let text = labels.get('offers_descl');
		if (props.item.offers_other_total === 1) {
			text = labels.get('offers_1_descl');
		} else if (props.item.offers_other_total === 2) {
			text = labels.get('offers_2_descl');
		} else if (props.item.offers_other_total === 3 || props.item.offers_other_total === 4) {
			text = labels.get('offers_3_descl');
		}

		const desc = labels
			.get('seller_others')
			.replace('%offers_total%', props.item?.offers_other_total || 0)
			.replace('%offers_descl%', text)
			.replace('%price%', firstOtherOffer.value?.price_custom || 0);

		// discount badge
		let badgeItem = null;
		if(props.item.offers?.length){
			let badgesToShow = ['1220795', '1220796', '1220797', '1220798', '1220799', '1220800', '1567938', '1567940', '1567943', '1567946', '1567947']; // prod
			if(['mp', 'local'].includes(config.default)) {
				badgesToShow = ['2232753', '2232754', '2232755', '2232756', '2232757', '2232758']; // dev
			}

			props.item.offers.forEach(offer => {
				if(offer.badges?.length && !badgeItem) {
					const badge = offer.badges.find(b => badgesToShow.includes(b.id));
					if(badge) badgeItem = badge;
				}
			});
		}

		if(badgeItem) {
			const badgeTitle = badgeItem.title.replace(/\d+\s/g, '').replace('UAU', '').replace('BF-UAU', '').trim();
			return desc + `<span class="cd-seller-desc-badge">${badgeTitle}</span>`;
		}

		return desc;
	});
	const offersFlyoutTitle = computed(() => {
		let text = labels.get('offers_descl');
		if (props.item.offers_other_total === 1) {
			text = labels.get('offers_1_descl');
		} else if (props.item.offers_other_total === 2) {
			text = labels.get('offers_2_descl');
		} else if (props.item.offers_other_total === 3 || props.item.offers_other_total === 4) {
			text = labels.get('offers_3_descl');
		}

		return labels
			.get('seller_flyout_title')
			.replace('%s%', props.item.offers_other_total ?? 0)
			.replace('%offers_descl%', text);
	});
	const offerShipping = computed(() => {
		if (firstMainOffer.value) {
			return firstMainOffer.value?.shipping_options?.find(option => option.id === firstMainOffer.value.shipping_type) || null;
		}
	});
	const offerShippingDate = computed(() => {
		return props.item.status == '5' ? firstMainOffer.value?.date_available : offerShipping.value?.min_delivery_date;
	});

	//time of delivery
	let shippingDate = ref();
	const tomorrow = new Date();
	tomorrow.setDate(tomorrow.getDate() + 1);
	if (offerShippingDate.value) {
		const calendarMonth = ['januarja', 'februarja', 'marca', 'aprila', 'maja', 'junija', 'julija', 'avgusta', 'septembra', 'oktobra', 'novembra', 'decembra'];
		const calendarDays = ['nedelje', 'ponedeljka', 'torka', 'srede', 'četrtka', 'petka', 'sobote'];
		const shippingDateDay = new Date(offerShippingDate.value * 1000).getDay();
		const shippingDateMonth = new Date(offerShippingDate.value * 1000).getMonth();

		if (calendarDays[shippingDateDay] && calendarMonth[shippingDateMonth]) {
			if (new Date(offerShippingDate.value * 1000).toDateString() === new Date().toDateString()) {
				shippingDate = new Date(offerShippingDate.value * 1000).getDate() + '.' + (new Date(offerShippingDate.value * 1000).getMonth() + 1) + '.';
			} else if (new Date(offerShippingDate.value * 1000).toDateString() === new Date(Date.now() + 86400000).toDateString()) {
				shippingDate = new Date(offerShippingDate.value * 1000).getDate() + '.' + (new Date(offerShippingDate.value * 1000).getMonth() + 1) + '.';
			} else {
				shippingDate = calendarDays[shippingDateDay] + ', ' + new Date(offerShippingDate.value * 1000).getDate() + '.' + (new Date(offerShippingDate.value * 1000).getMonth() + 1) + '.';
			}
		} else {
			shippingDate = new Date(offerShippingDate.value * 1000).toLocaleString('en-US', {weekday: 'short', day: 'numeric', month: 'long'});
		}
	}

	//select offer
	async function selectOffer(code) {
		emit('selectOffer', {'shopping_cart_code': code});
	}

	//flyout
	function flyoutLabel(title, content) {
		document.body.classList.add('flyout-page', 'cd-flyout-active');
		emit('flyoutUpdate', {'flyout_title': title ? title : null, 'flyout_content': content ? content : null});
	}

	function flyoutSellers(value, id) {
		document.body.classList.add('flyout-page', 'cd-flyout-active');
		emit('flyoutUpdate', {'flyout_mode': 'sellers', 'flyout_title': offersFlyoutTitle, 'flyout_content': value ? value : null, 'flyout_offer_id': id ? id : null});
	}
</script>

<style lang="less" scoped>
	.cd-sellers { width: 100%; margin-top: 20px; font-size: 15px; line-height: 1.4; font-weight: 600; }
	.cd-sellers-info {
		display: inline-block; padding: 10px 30px; background: #ffe555; font-size: 14px;
		@media (max-width: @ms) { display: block; padding: 10px 20px; }
	}
	.cd-sellers-info-btn {
		display: inline-block; padding-right: 15px; font-weight: 600; text-decoration: none; color: @blue; cursor: pointer; position: relative;
		a { text-decoration: none; }
		&:before { .icon-arrow-down(); font: 8px/8px @fonti; font-weight: 600; color: @blue; position: absolute; top: 7px; right: 0; .rotate(-90deg); .transition(right); }
		@media (min-width: @t) {
			&:hover {
				text-decoration: underline; color: @blue;
				a { text-decoration: underline; color: @blue; }
				&:before { right: -5px; }
			}
		}
	}
	.cd-sellers-info-content {
		ol {
			margin: 0 0 10px; counter-reset: item; list-style-type: none; position: relative;
			li {
				padding: 0 0 20px 40px; position: relative;
				&:before { .pseudo(28px,28px); content: counter(item) '.'; counter-increment: item; display: flex; align-items: center; justify-content: center; flex-shrink: 0; background: #ebf4ff; border-radius: 100%; font-size: 15px; font-weight: 600; color: @textColor; left: 0; top: -3px; }
			}
		}
	}

	.cd-seller-top {
		display: flex; align-items: center; padding: 20px 30px 20px 70px; background: #f3f6fa; border: 1px solid @borderColor; position: relative;
		&:before { .icon-shopping-bag(); font: 25px/1 @fonti; color: @blue; position: absolute; left: 29px; }

		@media (max-width: @t) {
			padding: 15px 25px 15px 60px;
			&:before { top: 14px; left: 22px; }
		}
		@media (max-width: @m) {
			padding: 13px 25px 13px 60px;
			&:before { font-size: 22px; line-height: 22px; }
		}
	}
	.cd-seller-title {
		display: block; margin-right: 8px; vertical-align: middle;
		.extra-name { display: block; margin-top: 3px; font-size: 12px; line-height: 15px; font-weight: normal; color: @inputTextColor; }
		a:hover { color: @blue; text-decoration: none; }
	}
	.cd-seller-rate { display: inline-flex; align-items: center; flex-shrink: 0; vertical-align: middle; }
	.cd-seller-condition {
		display: block; margin: 5px 0 0; padding-left: 23px; font-size: 15px; line-height: 1.4; font-weight: normal; position: relative;
		&:before { .icon-condition(); font: 15px/15px @fonti; color: @textColor; position: absolute; top: 4px; left: 0; }
		span { font-weight: 600; }

		@media (max-width: @m) {
			&:before { top: 5px; }
		}
	}
	.cd-seller-desc {
		margin-top: -1px; padding: 15px 75px 15px 25px; background: @white; border: 1px solid @borderColor; font-weight: normal; cursor: pointer; position: relative; .transition(border-color);
		&:before { .icon-arrow-down(); font: 12px/12px @fonti; font-weight: 600; color: @blue; position: absolute; top: 50%; right: 25px; transform: translateY(-50%) rotate(-90deg); }
		:deep(&>span){color: @blue; font-weight: 600;}
		:deep(.cd-seller-desc-badge){background: @green; color: #fff; padding: 3px 8px; margin-left: 10px; font-size: 12px; text-transform: uppercase;}
		@media (min-width: @t) {
			&:hover { border-color: @blue; }
			& > span:hover { text-decoration: none; }
		}
		@media (max-width: @t) {
			padding: 15px 60px 15px 15px;
			&:before { right: 20px; }
		}
		@media (max-width: @m) {
			padding: 15px 60px 15px 20px;
			&:before { font-weight: normal; right: 17px; }
		}
	}
</style>

<style lang="less">
	.cd-seller-item {
		display: flex; align-items: flex-end; width: 100%; margin: -1px 0 0; padding: 26px 25px; background: @white; border: 1px solid @borderColor; transition: box-shadow 0.3s, z-index 0.3s;
		&.active {
			background: #ebf4ff;
			&:hover { box-shadow: none; z-index: 0; }
			.cd-seller-item-btn {
				background: #7891a9; border-color: #7891a9; color: @white; pointer-events: none;
				.unselected { display: none; }
				.selected { display: block; }
			}
		}
		@media (min-width: @t) {
			&:hover { box-shadow: 0 0 15px 0 rgba(51, 51, 51, 0.1); z-index: 1; }
		}

		@media (max-width: @m) {
			display: block; padding: 20px;
		}
	}
	.cd-seller-item-col1 {
		flex-grow: 1; padding-right: 40px;

		@media (max-width: @m) {
			padding: 0 0 15px;
		}
	}
	.cd-seller-item-bottom { display: block; }
	.cd-seller-item-title {
		padding-left: 27px; font-size: 14px; line-height: 1.4; position: relative;
		&:before { .icon-shopping-bag(); font: 18px/1 @fonti; color: @textColor; position: absolute; top: 1px; left: 0; }
		a {
			font-weight: 600; color: @blue; text-decoration: underline;
			&:hover { color: @blue; text-decoration: none; }
		}
		span { color: @inputTextColor; }
	}
	.cd-seller-item-status{
		margin-bottom: 10px; font-size: 14px; line-height: 1.4; position: relative;

		@media (max-width: @m){margin-bottom: 7px;}
	}
	.cd-seller-item-rate { display: inline-flex; align-items: center; flex-shrink: 0; vertical-align: middle; }
	.cd-seller-item-info {
		display: flex; align-items: center; margin-bottom: 18px;

		@media (max-width: @m) {
			margin-bottom: 15px;
		}
	}
	.cd-seller-item-price { flex-shrink: 0; display: block; font-size: 17px; line-height: 1.3; font-weight: 600; }
	.cd-seller-item-condition {
		display: block; margin-left: 25px; padding-left: 21px; font-size: 14px; line-height: 1.5; position: relative;
		&:before { .icon-condition(); font: 14px/1 @fonti; color: @textColor; position: absolute; top: 5px; left: 0; }
	}
	.cd-seller-item-shipping {
		display: block; margin-bottom: 10px; padding-left: 27px; font-size: 14px; line-height: 1.4; position: relative;
		&:before { .icon-delivery(); font: 14px/1 @fonti; color: @textColor; position: absolute; top: 3px; left: 0; }

		@media (max-width: @m) {
			margin-bottom: 7px;
		}
	}
	.cd-seller-item-btn {
		flex-shrink: 0; min-width: 92px; height: 40px; padding: 0 20px; background: @white; border: 1px solid @blue; font-size: 15px; font-weight: 600; color: @blue; cursor: pointer; .transition(all);
		.selected { display: none; }
		&:hover { background: @blue; color: @white; }

		@media (max-width: @t) {
			background: @white; color: @blue;
			&:hover { background: @white; color: @blue!important; }
		}
	}
</style>
